import { createSlice } from '@reduxjs/toolkit';
import { addModel, fetchModels,fetchModelsByMake, removeModel, editModel } from '../actions/vehicleModels-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  isLoading: false,
  models: [],
  filteredModels: [],
  count: 0,
};

const modelsSlice = createSlice({
  name: 'vehicleModels',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchModels.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchModels.fulfilled, (state, action) => {
        const models = action.payload;
        state.models = models;
        state.isLoading = false;
        //state.status = Status.COMPLETED;
      })
      .addCase(fetchModels.rejected, (state, action) => {
        
      })
      .addCase(fetchModelsByMake.fulfilled, (state, action) => {
        const models = action.payload;
        state.filteredModels = models;
        state.isLoading = false;
        //state.status = Status.COMPLETED;
      })
      .addCase(addModel.fulfilled, (state, action) => {
        const newModel = action.payload;
        state.models.push(newModel);
      })
      .addCase(editModel.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.models.findIndex((model) => model.id === data.id);
        if (~index) {
          state.models[index] = data;
        }
      })
      .addCase(removeModel.fulfilled, (state, action) => {
        const modelId = action.payload;
        console.log(action.payload)

        state.models = state.models.filter((model) => model.id !== modelId);
      });
  },
});

export const modelsActions = modelsSlice.actions;

export default modelsSlice;
